// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1R7lR","content":"RecentSearches_content__1IbRe"};